import { call, put, takeEvery } from "redux-saga/effects";
import { GET_VENDORLIST_REQUESTED, GET_VENDORLIST_SUCCESS, GET_VENDORLIST_FAILED } from "resources/actionTypes";
import { getVendorsListApi } from "services/VendorService";

function* fetchVendorsList(action) {
  try {
    const searchText = action.payload?.search || ''
    const parentCompanyId = action.payload?.parentCompanyId || null
    const vendorList = yield call(getVendorsListApi, searchText, parentCompanyId);
    yield put({ type: GET_VENDORLIST_SUCCESS, vendorList: vendorList });
  } catch (e) {
    yield put({ type: GET_VENDORLIST_FAILED, message: e.message });
  }
}

export function* vendorListSaga() {
  yield takeEvery(GET_VENDORLIST_REQUESTED, fetchVendorsList);
}